import React from 'react';

import { Gutter } from '@common/components';
import {
  AuthTemplateCentralizedContainer,
  AuthTemplateLogo,
  ResetPasswordForm,
} from '@identity/components';

export const ResetPasswordPage = () => (
  <AuthTemplateCentralizedContainer>
    <AuthTemplateLogo />
    <Gutter internal size="xxl" />
    <ResetPasswordForm
      passwordName="new password"
      title="Reset password"
      submitButtomLabel="Reset Password"
      successMessage="Password successfully changed. Sign in to continue."
    />
  </AuthTemplateCentralizedContainer>
);
